(ns com.theplantscape.web-ui.tailwind.modal)

(defn simple-modal
  "https://tailwindui.com/components/application-ui/overlays/modals"
  [cfg]
  (when (:open-fn cfg)
    ((:open-fn cfg)))
  [:div.fixed.z-10.inset-0.overflow-y-auto {:aria-labelledby "modal-title" :role "dialog" :aria-modal "true"}
   [:div.flex.items-end.justify-center.min-h-screen.pt-4.px-4.pb-20.text-center.sm:block.sm:p-0
    [:div.fixed.inset-0.bg-gray-500.bg-opacity-75.transition-opacity {:aria-hidden "true"}]
    [:span.hidden.sm:inline-block.sm:align-middle.sm:h-screen {:aria-hidden "true"} "​"]
    [:div.inline-block.align-bottom.bg-white.rounded-lg.text-left.overflow-hidden.shadow-xl.transform.transition-all.sm:my-8.sm:align-middle.sm {:class "w-full sm:w-4/5 md:w-4/5"}
     [:div.bg-white.px-4.pt-5.pb-4.sm:p-6.sm:pb-4
      [:div.flex
       [:div.flex-shrink-0.flex.items-center.justify-center.h-12.w-12.rounded-full.bg-red-100.sm:mx-0.sm:h-10.sm:w-10
        [:svg.h-6.w-6.text-red-600 {:xmlns "http://www.w3.org/2000/svg" :fill "none" :viewBox "0 0 24 24" :stroke "currentColor" :aria-hidden "true"}
         [:path {:stroke-linecap "round" :stroke-linejoin "round" :stroke-width "2" :d "M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"}]]]
       [:div.grow.mt-2.text-center.sm:mt-0.sm:ml-4.sm:text-left
        [:h3#modal-title.inline-block.ml-4.text-4xl.leading-6.font-medium.text-gray-900
         (:title cfg)]]
       [:button.justify-center.rounded-md.border.border-gray-300.shadow-sm.px-4.py-2.bg-white.text-base.font-medium.text-gray-700.hover:bg-gray-50.focus:outline-none.focus:ring-2.focus:ring-offset-2.focus:ring-indigo-500.sm:mt-0.sm:ml-3.sm:w-auto.sm:text-sm
        {:type "button" :on-click (fn close-simple-modal [_] ((:close-fn cfg)))} " X "]]]
     [:div (:body cfg)]
     [:div.bg-gray-50.px-4.py-3.sm:px-6.sm:flex.sm:flex-row-reverse
      [:button.mt-3.w-full.inline-flex.justify-center.rounded-md.border.border-gray-300.shadow-sm.px-4.py-2.bg-white.text-base.font-medium.text-gray-700.hover:bg-gray-50.focus:outline-none.focus:ring-2.focus:ring-offset-2.focus:ring-indigo-500.sm:mt-0.sm:ml-3.sm:w-auto.sm:text-sm
       {:type "button" :on-click (fn close-simple-modal [_] ((:close-fn cfg)))} " Close "]]]]])

(defn image-modal [image close-fn]
  [:div#modal.fixed.top-0.left-0.z-80.w-screen.h-screen.flex.justify-center.items-center.bg-black
   {:class ""}
   [:a.fixed.z-90.top-6.right-8.text-white.text-5xl.font-bold
    {:on-click close-fn} "×"]
   [:img#modal-img.p-4.object-cover.object-scale-down
    {:class "" :src image}]])
